import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Paper,
  Divider,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Box

} from '@material-ui/core';
import Alert from 'src/components/Alert';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Segoe UI",
    width: '100%',
    height: '100%'
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },

}));

function ReportMonitoring() {

  const classes = useStyles();
  const SessionUser = getUser();
  const [reportData, setReportData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [detailPopup, setDetailPopup] = React.useState(false);
  const [renk, setRenk] = React.useState('black');
  const [detailData, setDetailData] = React.useState([]);
  const [detailDataParametres, setDetailDataParametres] = React.useState([]);
  const [kulparamArrays, setKulparamArrays] = React.useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });


  useEffect(() => {
    handleReportMonitoring();
  }, []);

  const handleReportMonitoring = () => {
    HandleChangeColorResetClick();
    setLoading(true);
    axios.get(`GetReportMonitoring/${SessionUser.TopServiceShopCode}`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        setReportData(data);
      }).catch((error) => {
        setLoading(false);
        return;
      });
  };

  const handleReportDetail = (Id) => {
    setDetailPopup(true);
    setLoading(true);
    axios.get(`GetSarisReportDetail/${Id}`)
      .then((response) => {
        setLoading(false);
        var data = response.data[0];
        setDetailData(data)
      }).catch((error) => {
        setLoading(false);
        return;
      });
    setLoading(true);
    axios.get(`GetSarisReportDetailParametres/${Id}`)
      .then((response) => {
        setLoading(false);
        var datax = response.data;
        const newData = response.data[0].KULPARAM
        const kulparam = newData;
        const kulparamArray = kulparam.split(',');
        setKulparamArrays(kulparamArray)
        setDetailDataParametres(datax);
      }).catch((error) => {
        setLoading(false);
        return;
      });




  }

  const handleButtonClick = (Id) => {
    setLoading(true);
    axios.get(`SarisReportDelete/${Id}`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == "1000") {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        }
        else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          return;
        }
      }).catch((error) => {
        setLoading(false);
        return;
      });
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function HandleChangeColorClick(Color) {
    setRenk({ ...renk, [Color]: '#0033a0' });
  }
  function HandleChangeColorResetClick() {
    setRenk('black');
  }

  function HandleResertAndClose() {
    setDetailPopup(false);
    setKulparamArrays([]);
    setDetailDataParametres([]);
    setDetailData([]);
  }

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardContent>
          <Grid item xs={12} sm={12} md={12}>

            <Divider style={{ margin: '1rem' }} />
            <Typography
              align='center'
              style={{ marginBottom: '1rem', color: '#0033a0', fontWeight: 'bold', fontSize: '1.2rem' }}
            >
              Silmek istediğiniz rapor isteğini İPTAL seçeneği ile silebilirsiniz.
            </Typography>
            <Divider style={{ margin: '1rem' }} />
            <TableContainer component={Paper}>
              <Table size='medium'>

                <TableHead>
                  <TableRow>
                    <TableCell
                      align='center'
                      style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}
                    >
                      No
                    </TableCell>
                    <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                      Açıklama
                    </TableCell>
                    <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                      Kullanıcı
                    </TableCell>
                    <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                      İstek Tarihi
                    </TableCell>
                    <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                      Durum
                    </TableCell>
                    <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                      İptal
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    reportData?.map((row) => (
                      <TableRow hover key={row.ID}>
                        <TableCell onClick={() => { handleReportDetail(row.ID); }}><Typography style={{ borderBottom: '1px solid #00000050', textAlign: 'center', color: renk[row.ID] || 'black', borderColor: renk[row.ID] || 'black' }} onClick={() => { HandleChangeColorClick(row.ID); }}>{row.ID}</Typography></TableCell>
                        <TableCell>{row.RAPORTANIM}</TableCell>
                        <TableCell>{row.ADSOYAD}</TableCell>
                        <TableCell>{moment(row.VERILIS_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                        <TableCell>{row.DURUM_ACIKLAMA}</TableCell>
                        <TableCell>
                          {row.DURUM === 0 ? (
                            <Button variant="contained" color="secondary" onClick={() => handleButtonClick(row.ID)}>
                              İptal
                            </Button>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  }

                </TableBody>
              </Table>
            </TableContainer>
            <Divider style={{ margin: '1rem' }} />
            <Typography
              align='center'
              style={{ marginBottom: '1rem', color: '#0033a0', fontWeight: 'bold', fontSize: '1.2rem' }}
            >
              Son 50 istek listelenmiştir.
            </Typography>
            <Divider style={{ margin: '1rem' }} />
          </Grid>
        </CardContent>
      </Card >
      <Dialog
        open={detailPopup}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <TableContainer component={Paper}>
            <Table size='medium'>

              <TableHead>
                <TableRow>
                  <TableCell
                    align='center'
                    style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}
                  >
                    Rapor İstek No
                  </TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                    Durum
                  </TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                    Rapor Tanım
                  </TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                    İstek Tarihi
                  </TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                    Durum Tarihi
                  </TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                    Raporu İsteyen
                  </TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}>
                    E-mail
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow hover key={detailData?.ID}>
                  <TableCell >{detailData?.ID}</TableCell>
                  <TableCell>{detailData?.DURUM_ACIKLAMA}</TableCell>
                  <TableCell>{detailData?.RAPORTANIM}</TableCell>
                  <TableCell>{moment(detailData?.VERILIS_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                  <TableCell>{moment(detailData?.ISTEK_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                  <TableCell>{detailData?.ADSOYAD}</TableCell>
                  <TableCell>{detailData?.EMAIL}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <br></br>
          <TableContainer component={Paper}>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}><strong>Sıra No</strong></TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}><strong>Değişken Adı</strong></TableCell>
                  <TableCell style={{ border: '1px solid #ddd', color: '#fff', backgroundColor: '#0033a0' }}><strong>Parametreler</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detailDataParametres?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.SIRA_NO}</TableCell>
                    <TableCell>{row.DEGISKEN_ADI}</TableCell>
                    <TableCell>{kulparamArrays[index]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            aria-label="close"
            onClick={() => { HandleResertAndClose(); }}
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog >
    </>
  );

}

export default ReportMonitoring;